import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandFuelTruckAddPage } from './cabsand-fuel-truck-add';

@NgModule({
  declarations: [
    CabsandFuelTruckAddPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandFuelTruckAddPage),
  ],
})
export class CabsandFuelTruckAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-fuel-truck-add/cabsand-fuel-truck-add.module.ts